module.exports = __webpack_public_path__ + "img/spellcaster.f7a118a7.png";